module.exports = __webpack_public_path__ + "img/qq_group_qrcode.d7266e07.jpg";